var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalLoanProductType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22V16H52.9995V22H52C51.4477 22 51 22.4477 51 23C51 23.5523 51.4477 24 52 24H52.9995C54.1041 24 54.9995 23.1046 54.9995 22V16C54.9995 14.9099 54.1295 14 53.0105 14H6.98497C5.86073 14 5 14.9153 5 16V22C5 23.1046 5.89543 24 7 24H8C8.55228 24 9 23.5523 9 23C9 22.4477 8.55228 22 8 22H7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 18H9V20H11V43C11 44.6569 12.3431 46 14 46H46C47.6569 46 49 44.6569 49 43V20H50.5V18ZM18 44H42V42H18V44ZM16 42V44H14C13.4477 44 13 43.5523 13 43V42H16ZM18 40H42V38H18V40ZM16 38V40H13V38H16ZM18 36H42V34H18V36ZM16 34V36H13V34H16ZM18 32H42C42 29.2386 44.2386 27 47 27V20H38C38 24.4183 34.4183 28 30 28C25.5817 28 22 24.4183 22 20H13V27C15.7614 27 18 29.2386 18 32ZM13 29C14.6569 29 16 30.3431 16 32H13V29ZM46 44H44V42H47V43C47 43.5523 46.5523 44 46 44ZM47 40H44V38H47V40ZM47 36H44V34H47V36ZM47 32H44C44 30.3431 45.3431 29 47 29V32ZM24 20C24 23.3137 26.6863 26 30 26C33.3137 26 36 23.3137 36 20H24Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLoanProductType);
export default __webpack_public_path__ + "static/media/personal-loan-product-type.799cdb0e.svg";
export { ForwardRef as ReactComponent };